import React from 'react';
import styles from './PricingPlan.module.css'; // Adjust the path as necessary
import Plan from './Plan.js';
import { useTranslation } from 'react-i18next'; // Import the useTranslation hook
import { useSelector } from 'react-redux';

const Plans = () => {
    const { t } = useTranslation(); // Initialize the translation function
    const user = useSelector(state => state.user?.user);
    
    // Create plans only when the price data is available
    const plansData = [];
    
    // 1 month plan
    if (user?.verificationPriceFor1Month?.unit_amount) {
        plansData.push({
            title: t('plans.1_month_plan.title'),
            description: t('plans.1_month_plan.description'),
            price: `$${user.verificationPriceFor1Month.unit_amount / 100} /mo`,
            link: 'https://buy.stripe.com/test_aEUcQw1AL03h0WQ4gj',
            // https://buy.stripe.com/28o9D121s6QK9MYbIJ
            discount: t('plans.1_month_plan.discount') + ' 10%',
            id: process.env.REACT_APP_STRIPE_VERIFICATION_PRICE_ID_FOR_1_MONTH_RECURRING,
            buttonText: user?.subscriptionStatus ?
                user?.subscriptionStatus?.toUpperCase() == t('billing.activeStatus')?.toUpperCase() ?
                    user?.activeSubscriptionPriceId == process.env.REACT_APP_STRIPE_VERIFICATION_PRICE_ID_FOR_1_MONTH_RECURRING ?
                        t('billing.activeStatus') :
                        t('plans.1_month_plan.button_upgrade_text') :
                    t('moneyBack.buttonText')
                : t('moneyBack.buttonText')
        });
    }
    
    // 3 month plan
    if (user?.verificationPriceFor2Month?.unit_amount) {
        plansData.push({
            title: t('plans.3_month_plan.title'),
            description: t('plans.3_month_plan.description'),
            price: `$${user.verificationPriceFor2Month.unit_amount / 100} /3 mo`,
            link: 'https://buy.stripe.com/test_cN2eYE93d3ft5d65ko',
            // https://buy.stripe.com/00gcPdgWma2Wf7i5km
            id: process.env.REACT_APP_STRIPE_VERIFICATION_PRICE_ID_FOR_2_MONTH_RECURRING,
            discount: t('plans.3_month_plan.discount') + ' 17%',
            buttonText: user?.subscriptionStatus ?
                user?.subscriptionStatus?.toUpperCase() == t('billing.activeStatus')?.toUpperCase() ?
                    user?.activeSubscriptionPriceId == process.env.REACT_APP_STRIPE_VERIFICATION_PRICE_ID_FOR_2_MONTH_RECURRING ?
                        t('billing.activeStatus') :
                        t('plans.1_month_plan.button_upgrade_text') :
                    t('moneyBack.buttonText')
                : t('moneyBack.buttonText')
        });
    }
    
    // 6 month plan
    if (user?.verificationPriceFor3Month?.unit_amount) {
        plansData.push({
            title: t('plans.6_month_plan.title'),
            description: t('plans.6_month_plan.description'),
            price: `$${user.verificationPriceFor3Month.unit_amount / 100} /6 mo`,
            id: process.env.REACT_APP_STRIPE_VERIFICATION_PRICE_ID_FOR_3_MONTH_RECURRING,
            link: 'https://buy.stripe.com/test_bIY03Kenx03hdJC006',
            // https://buy.stripe.com/8wM16v5dEdf87EQaEH
            discount: t('plans.6_month_plan.discount') + ' 33%',
            buttonText: user?.subscriptionStatus ?
                user?.subscriptionStatus?.toUpperCase() == t('billing.activeStatus')?.toUpperCase() ?
                    user?.activeSubscriptionPriceId == process.env.REACT_APP_STRIPE_VERIFICATION_PRICE_ID_FOR_3_MONTH_RECURRING ?
                        t('billing.activeStatus') :
                        t('plans.1_month_plan.button_upgrade_text') :
                    t('moneyBack.buttonText')
                : t('moneyBack.buttonText')
        });
    }
    
    const activeSubscriptionIndex = () => {
        if (user?.subscriptionStatus?.toUpperCase() == t('billing.activeStatus')?.toUpperCase() && user?.activeSubscriptionPriceId == process.env.REACT_APP_STRIPE_VERIFICATION_PRICE_ID_FOR_1_MONTH_RECURRING) {
            return 0
        }
        else if (user?.subscriptionStatus?.toUpperCase() == t('billing.activeStatus')?.toUpperCase() && user?.activeSubscriptionPriceId == process.env.REACT_APP_STRIPE_VERIFICATION_PRICE_ID_FOR_2_MONTH_RECURRING) {
            return 1

        }
        else if (user?.subscriptionStatus?.toUpperCase() == t('billing.activeStatus')?.toUpperCase() && user?.activeSubscriptionPriceId == process.env.REACT_APP_STRIPE_VERIFICATION_PRICE_ID_FOR_3_MONTH_RECURRING) {

            return 2
        } else {
            return -1
        }
    }

    return (
        <div style={{
            position: "relative",
            overflow: "hidden"
        }}>
            <div className={styles.content}>
                <i></i>
                <i></i>
                <i></i>
            </div>
            <p className={styles.moneyBackTitle}>{t('plans.title')}</p>
            <div className={`${styles.plansContainer} ${styles.fcvRow}`}>
                {plansData.map((plan, index) => (
                    <Plan
                        key={index}
                        currentIndex={index}
                        title={plan.title}
                        description={plan.description}
                        price={plan.price}
                        priceId={plan.id}
                        email={user?.email}
                        discount={plan.discount}
                        link={plan.link} // Pass link prop here
                        buttonText={plan.buttonText}
                        activeSubscriptionIndex={activeSubscriptionIndex()}
                    />
                ))}
            </div>
        </div>
    );
};

export default Plans;
